import { Alert } from "@mui/material";
import { useEffect } from "react";
import { useWatch } from "react-hook-form";

const SiteSelectionAlert = ({
  fetchSitesData,
  sitesNotInTestMode,
}: {
  fetchSitesData: (siteIds: number[]) => void;
  sitesNotInTestMode: string[];
}) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const siteIds = useWatch({ name: "siteIds" }) || [];

  useEffect(() => {
    fetchSitesData(siteIds);
  }, [siteIds, fetchSitesData]);

  if (sitesNotInTestMode.length === 0) return null;

  return (
    <Alert severity="warning" sx={{ gridColumn: "1 / -1", mb: 2 }}>
      <strong>Warning:</strong> Not in test mode:
      <ul style={{ margin: "8px 0 0 0", paddingLeft: "20px" }}>
        {sitesNotInTestMode.map((site, index) => (
          <li key={index}>{site}</li>
        ))}
      </ul>
    </Alert>
  );
};

export default SiteSelectionAlert;
